"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSuggestionAddressComponents = instanceOfSuggestionAddressComponents;
exports.SuggestionAddressComponentsFromJSON = SuggestionAddressComponentsFromJSON;
exports.SuggestionAddressComponentsFromJSONTyped = SuggestionAddressComponentsFromJSONTyped;
exports.SuggestionAddressComponentsToJSON = SuggestionAddressComponentsToJSON;
exports.SuggestionAddressComponentsToJSONTyped = SuggestionAddressComponentsToJSONTyped;
/**
 * Check if a given object implements the SuggestionAddressComponents interface.
 */
function instanceOfSuggestionAddressComponents(value) {
    if (!('streetName' in value) || value['streetName'] === undefined)
        return false;
    if (!('streetType' in value) || value['streetType'] === undefined)
        return false;
    if (!('streetTypeLong' in value) || value['streetTypeLong'] === undefined)
        return false;
    if (!('suburb' in value) || value['suburb'] === undefined)
        return false;
    if (!('postCode' in value) || value['postCode'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    return true;
}
function SuggestionAddressComponentsFromJSON(json) {
    return SuggestionAddressComponentsFromJSONTyped(json, false);
}
function SuggestionAddressComponentsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'unitNumber': json['unitNumber'] == null ? undefined : json['unitNumber'],
        'streetNumber': json['streetNumber'] == null ? undefined : json['streetNumber'],
        'streetName': json['streetName'],
        'streetType': json['streetType'],
        'streetTypeLong': json['streetTypeLong'],
        'suburb': json['suburb'],
        'postCode': json['postCode'],
        'state': json['state'],
    };
}
function SuggestionAddressComponentsToJSON(json) {
    return SuggestionAddressComponentsToJSONTyped(json, false);
}
function SuggestionAddressComponentsToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'unitNumber': value['unitNumber'],
        'streetNumber': value['streetNumber'],
        'streetName': value['streetName'],
        'streetType': value['streetType'],
        'streetTypeLong': value['streetTypeLong'],
        'suburb': value['suburb'],
        'postCode': value['postCode'],
        'state': value['state'],
    };
}
